import React from "react";
import Loader from "react-loader-spinner";
// import { Calendar, DatePicker } from 'react-persian-datepicker';
// import DatePicker from 'react-datepicker-persian';
// import moment from 'moment'
// import 'react-datepicker-persian/dist/react-datepicker-persian.min.css';
// used for making the prop types of this component
// import PropTypes from "prop-types";
// var moment = require('moment-jalaali');
// import fa from "moment/src/locale/fa";

var moment = require('jalali-moment');
// moment().locale('fa').format('YYYY/M/D');
// moment.loadPersian({usePersianDigits: true})
// moment.locale("fa", fa);
// moment.loadPersian();

class DateIndicator extends React.Component {

    state = {
        // title: moment(),
        isOpen: false,
        startOfMonth: '',
        endOfMonth: '',
        week: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        months: [
            { title: 'January' },
            { title: 'February' },
            { title: 'March' },
            { title: 'April' },
            { title: 'May' },
            { title: 'June' },
            { title: 'July' },
            { title: 'August' },
            { title: 'September' },
            { title: 'October' },
            { title: 'November' },
            { title: 'December' },
        ],
        years: []
        // currentTime
    }

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    componentDidMount() {
        // console.log(moment().day())
        // let now = new Date().getTime() 
        // this.setState({ title: noew })

        this.setState({ title: this.props.title, today: new Date().getTime() })
        window.addEventListener('resize', this.changeWidth);
        setTimeout(() => {
            this.changeWidth()
        }, 100);
        // // this.props.onChange(this.props.headerkey, day.start)

        // console.log(new Date().getTime())
        if (this.props.title) {
            this.setMonth(0, this.props.title)

        } else {
            this.setMonth(0)
        }
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.title != prevProps.title) {
    //         this.setMonth(0, this.props.title)
    //     }
    // }

    changeMonth(number) {
        // console.log("CHANGE MONTH")
        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    setMonth(fromNow, startDate) {
        console.log("SET MONTH")
        console.log(fromNow)
        // this.setState({month:{}},()=>{

        // console.log(startDate)
        let now = new Date();
        let days = []

        let start = moment(now).startOf('month').add(fromNow, 'month').startOf('month')

        if (startDate) {
            start = moment(startDate).add(fromNow, 'month').startOf('month')
            // console.log()
        }
        // let end = moment(now).add(fromNow, 'jmonth').endOf('jmonth')
        // let count = 0

        for (let i = 0; i < moment(now).add(fromNow, 'month').daysInMonth(); i++) {

            days.push({ start: moment(start).add(i, 'day').startOf('day').valueOf(), end: moment(start).add(i, 'day').endOf('day').valueOf() })
            // count++
        }
        // console.log(days)

        // this.setState({ isOpen: false }, () => {
        // console.log("**")
        // console.log(moment(start).format('M'))
        let newDate = [Number(moment(start).format('YYYY')), moment(start).format('M') - 1, 1]

        this.setState({ month: { title: moment(start).format('YYYY-MMMM'), month: moment(start).format('MMMM'), monthNumber: moment(start).format('M') - 1, year: Number(moment(start).format('YYYY')), startDay: start.day(), days: days } }, () => {

            this.props.onChange(this.props.headerkey, { type: 'changeDate', newDate })

        })

    }

    setDay(day, dayNumber) {

        this.setState({ title: day.start })
        this.props.onChange(this.props.headerkey, { type: 'changeDay', newDay: day.start, dayNumber })
        // this.props.onChange(this.props.headerkey, day.start)

    }

    showDays() {

        // let day = 1
        let week = []
        let weeks = []
        let days = []
        let startDay = this.state.month.startDay

        // let firstWeek = true
        let count = 0
        // console.log(startDay)
        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }
        if (!this.state.month.days) {
            return
        }

        days = [...days, ...this.state.month.days]

        for (let i = 0; i < days.length; i++) {
            // console.log("HERE")
            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }

        // console.log(weeks)

        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {
                // console.log("HERE")
                weeks[weeks.length - 1].push(null)
            }
        }


        // console.log(weeks)
        // console.log(weeks)
        count = 0

        return weeks.map((week, index) => {

            // if(index ==  )
            return (
                <div key={index} className="d-flex text-center pl-1 pr-1 w-100" style={{ justifyContent: 'space-between' }}>
                    {week.map((day, index1) => {
                        // console.log(count)
                        if (day == null) {
                            return (
                                <div key={index1} style={{ textTransform: 'uppercase', width: '100%', margin: -1, border: '1px solid transparent' }}>
                                </div>
                            )
                        } else {
                            count++
                            let dayNumber = count

                            let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                            let selectedDay = (this.state.title >= day.start && this.state.title <= day.end) ? true : false

                            return (
                                <div onClick={() => this.setDay(day, dayNumber)} key={index1} style={{ overflow: 'hidden', cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#e2e8ea' : '#fcfcfc', padding: 0, borderRadius: 0, width: "100%", minHeight: 80, justifyContent: 'center', alignItems: 'center', display: 'flex', border: '1px solid #eee', margin: -1 }}>
                                    <div style={{ backgroundColor: isToday ? '#00206010' : 'transparent', borderRadius: 0, padding: "10px 10px", width: "100%", height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                                        <p style={{ color: selectedDay ? '#789' : '#789', fontSize: 12, fontWeight: 'bold' }}>{count}</p>
                                        {/* {count % 2 == 0 && ( */}

                                        <div className="flexcc w-100 flex-column">
                                            {this.props.data && Array.isArray(this.props.data[count]) && (
                                                // <div>
                                                //     {this.props.data[count].length > 2 && (
                                                //         this.props.data[count].map((prop, index) => {
                                                //             return (
                                                //                 <div style={{ backgroundColor: '#e4e9f0', padding: '5px 15px', borderRadius: 4, marginTop: 3 }}>
                                                //                     <p style={{ fontSize: 12, fontWeight: 'bold', color: '#101010', }}>{this.props.data[count].length + " Actions"}</p>
                                                //                     {/* <p style={{ fontSize: 11, color: '#101010', }}>{"RO-123"}</p> */}
                                                //                 </div>
                                                //             )
                                                //         })
                                                //     )}


                                                // </div>
                                                <div className="w-100 text-center" style={{ overflow: 'hidden', backgroundColor: '#677dc4', padding: '5px 5px', borderRadius: 4, marginTop: 3 }}>
                                                    <p style={{ fontSize: 11, color: '#fff', }}>{this.props.data[count].length}{this.state.width > 550 ? " EVENTS" : ''}</p>
                                                    {/* <p style={{ fontSize: 11, color: '#101010', }}>{"RO-123"}</p> */}
                                                </div>
                                            )}

                                            {this.state.width > 550 && (!this.props.data || !Array.isArray(this.props.data[count]) || this.props.data[count].length == 0) && (
                                                <p className='mt-2' style={{ fontSize: 12, color: '#bcd' }}>NO DATA</p>
                                            )}
                                        </div>
                                        {/* )} */}
                                    </div>
                                </div>
                            )
                        }
                    })
                    }

                </div>
            )
        })




    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('resize', this.changeWidth);

    }

    openBox() {
        document.addEventListener('mousedown', this.closeBox);
        this.setState({ isOpen: true })
    }


    changeWidth = () => {
        if (this.calender) {
            let width = this.calender.getBoundingClientRect().width
            this.setState({ width })
        }
    }

    closeBox = (event) => {
        // if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
        setTimeout(() => {
            this.setState({ showMonths: false, showYears: false })
        }, 300);
        document.removeEventListener('mousedown', this.closeBox);
        //     if (this.refs.icon)
        //         this.refs.icon.classList.toggle("rotate-180")

        // }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    showMonths = () => {
        this.setState({ showMonths: true, showYears: false })
        document.removeEventListener('mousedown', this.closeBox);
        setTimeout(() => {
            document.addEventListener('mousedown', this.closeBox);
        }, 500);

    }

    showYears = () => {
        let startYear = 2019
        let endYear = Number(moment().year())
        let years = []

        for (var i = startYear; i <= endYear; i++) {
            years.push(i);
        }

        this.setState({ showMonths: false, showYears: true, years })
        document.removeEventListener('mousedown', this.closeBox);
        setTimeout(() => {
            document.addEventListener('mousedown', this.closeBox);
        }, 500);

    }


    setNewDate = (type, prop, index) => {
        let oldDate = [this.state.month.year, this.state.month.monthNumber, 1]
        let newDate = [this.state.month.year, this.state.month.monthNumber, 1]

        if (type == 'month') {
            newDate[1] = index
        }
        if (type == 'year') {
            newDate[0] = prop
        }

        // console.log(newDate)

        // let oldDate = []//this.state.month.title.split('-')
        // oldDate.push(1)

        // oldDate[1] = moment().month(oldDate[1]).format("M");
        // console.log(oldDate)
        // 
        // console.log(moment(newDate).valueOf())


        let monthsDiff = moment(newDate).startOf('month').diff(moment(new Date()).startOf('month'), 'months', true)

        // console.log(monthsDiff)
        if (this.props.title) {
            this.setMonth(monthsDiff, this.props.title)

        } else {
            this.setMonth(monthsDiff)
        }
        // console.log(monthsDiff)
    }


    render() {
        let info = this.props.info
        return (
            <div ref={el => this.calender = el} className='w-100' style={{ position: 'relative' }}>
                {/* <label className={'mb-2 mr-1 ml-1 ' + (this.conditionalSettings("required", true) ? 'required' : '')} style={{ marginBottom: 3, fontSize: 12, marginTop: 5, color: '#999' }}>{this.props.label}</label> */}
                {/* <input disabled={info.disabled} onChange={e => { this.props.onChange(this.props.headerkey, e.target.value) }} className='form-control' defaultValue={this.props.title} placeholder={info.placeHolder} style={{ backgroundColor: '#f7f7f7', color: '#3b3a40' }} /> */}
                <div className='position-relative' ref={ref => this.setWrapperRef(ref)}>
                    {/* <div onClick={() => this.openBox()} disabled={(this.conditionalSettings("disabled", true))} onChange={e => { this.props.onChange(this.props.headerkey, e.target.value) }} className='form-control' defaultValue={this.props.title} style={{ backgroundColor: '#f7f7f7', color: '#3b3a40', height: 35, display: 'flex', alignItems: 'center' }} >
                        <p>{this.state.title ? moment(this.state.title).format('YYYY - MMMM - DD') : ''}</p>
                    </div> */}

                    {/* {this.state.isOpen && ( */}
                    <div style={{ backgroundColor: '#fff', width: '100%', padding: 0 }}>
                        <div className="d-flex p-2 mb-2" style={{ backgroundColor: '#f2f6f8', borderRadius: 4, justifyContent: 'space-between' }}>
                            <div className="flexcc">
                                <img className="reverse" onClick={() => this.changeMonth(-1)} src="/images/nexts.png" height="16px" />
                            </div>
                            <div className="d-flex" style={{ position: 'relative', alignItems: 'center', justifyContent: 'center' }}>
                                <span style={{ cursor: 'pointer', textTransform: 'uppercase', fontWeight: 'bold', backgroundColor: '#d0d6dd', color: '#000', borderRadius: 5, padding: '3px 10px' }} onClick={() => this.showYears()}>{this.state.month.year}</span>    <span className="mx-1" style={{ cursor: 'pointer', textTransform: 'uppercase', fontWeight: 'bold',backgroundColor: '#d0d6dd', color: '#000', borderRadius: 5, padding: '3px 10px' }} onClick={() => this.showMonths()}>{this.state.month.month}</span>
                                {this.state.showMonths && (
                                    <div style={{ position: 'absolute', top: 24, backgroundColor: '#fff', borderRadius: 4, boxShadow: '0px 0px 100px #00000020', padding: '0px 0px', textAlign: 'center' }}>
                                        {this.state.months.map((prop, index) => {
                                            return (
                                                <div onClick={() => this.setNewDate('month', prop, index)} key={index} className="" style={{ cursor: 'pointer', borderBottom: '1px solid #eee', padding: '5px 35px' }}>
                                                    <p>{prop.title}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}


                                {this.state.showYears && (
                                    <div style={{ position: 'absolute', top: 24, backgroundColor: '#fff', borderRadius: 4, boxShadow: '0px 0px 100px #00000020', padding: '0px 0px', textAlign: 'center' }}>
                                        {this.state.years.map((prop, index) => {
                                            return (
                                                <div onClick={() => this.setNewDate('year', prop, index)} key={index} className="" style={{ cursor: 'pointer', borderBottom: '1px solid #eee', padding: '5px 35px' }}>
                                                    <p>{prop}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>
                            <div className="flexcc">
                                <img onClick={() => this.changeMonth(1)} src="/images/nexts.png" height="16px" />
                            </div>
                        </div>

                        <div className="d-flex p-2  text-center w-100" style={{ justifyContent: 'space-between' }}>
                            {this.state.week.map((prop, index) => {
                                return (
                                    <div className={'w-100'} style={{ width: 35, }}>
                                        <p style={{ color: '#789', fontSize: 12, textTransform: 'uppercase' }}>{prop}</p>
                                    </div>
                                )
                            })}
                        </div>

                        {this.showDays()}

                    </div>
                    {/* )} */}

                </div>

                {this.props.isLoading && (
                    <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', backgroundColor: '#00000020', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                        <Loader
                            type="Oval"
                            color="rgba(0,122,255,1)"
                            height="80"
                            width="80"
                        />
                    </div>
                )}

            </div>
        );
    }
}

export default DateIndicator;
